export default function IconButton({
  disabled = false,
  bgColor,
  icon,
  text,
  textColor,
  onClick,
}) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`font-[poppins] px-6 py-2 border-1 border-[#092F7B] rounded-[10px] cursor-pointer text-white flex items-center justify-center space-x-1 ${bgColor}`}
    >
      <img src={icon} alt={text} />
      <p className={`text-sm ${textColor} font-medium`}>{text}</p>
    </button>
  );
}
